<template>
  <a-modal v-model="visible" title="即将到期任务" width="800px" wrapClassName="upcoming-task-modal" @ok="visible = false">
    <div class="relation-work">
      <div class="work-list">
        <div class="work-item" v-for="(item, key) in list" :key="key">
          <div class="text-block">{{item.prj_name}}</div>
          <div class="text-block blue">{{item.phase_name}}</div>
          <div class="text-block">{{item.issue_code}}</div>
          <div class="text-block gray">{{item.issue_name}}</div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {fetch} from "@/utils/request";

export default {
  emits: ['changeCount'],
  data() {
    return {
      visible: false,
      list: []
    }
  },
  created() {
    if (localStorage.getItem('open_upcoming_task_modal') === '1') {
      this.getList()
      localStorage.removeItem('open_upcoming_task_modal')
    }
  },
  methods: {
    getList() {
      const company_info = JSON.parse(localStorage.getItem("company_info"))
      fetch("post", "/prj/issue/deadline", {
        coid: company_info.coid
      }).then(res => {
        if (res.status === 0) {
          this.list = res.data
          if (res.data.length > 0) {
            this.visible = true
          }
          this.$emit('changeCount', res.data.length)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .upcoming-task-modal {
  .ant-modal-body {
    padding: 0;
  }
}
.relation-work {
  .work-list {
    overflow-y: auto;

    .work-item {
      padding: 0 20px;
      display: flex;
      height: 45px;
      align-items: center;
      border-bottom: 1px solid #EDEDED;;

      &:nth-child(2n) {
        background-color: #F8F8F8;
      }

      .ant-checkbox-wrapper {
        pointer-events: none;
        margin-right: 8px;
      }

      .text-block {
        margin-right: 10px;
        font-weight: 500;
        font-size: 12px;
        color: #303030;

        &.xk {
          max-width: 170px;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出不换行
        }

        &.gray, &.blue, &.red, &.green, &.yellow {
          padding: 2px 5px;
          border-radius: 4px;
        }

        &.gray {
          background-color: #EEE;
        }

        &.green {
          background-color: #E0F7F0;
          color: #2ECC74;
        }

        &.blue {
          background-color: #E0EEF7;
          color: #38A3FF;
        }

        &.yellow {
          background-color: #FAF4D9;
          color: #FFC600;
        }

        &.red {
          background-color: #F75858;
          color: white;
        }
      }

      .icon {
        margin-right: 8px;
        height: 20px;
      }

      .status {
        margin-left: auto;
        height: 25px;
        line-height: 23px;
        border-radius: 20px;
        border: 1px solid #eee;
        font-size: 12px;
        padding: 0 15px;

        &.blue {
          border-color: var(--primary-color);
          color: var(--primary-color);
        }
      }
    }
  }
}
</style>
